<template>
  <Modal
    v-model="_value"
    width="500"
    title="锐明设置司机卡"
    @on-visible-change="visibleChange"
    ok-text="关闭"
    cancel-text="">
    <Form ref="setDriverCardParamsRef" v-model="setDriverCardParams" :label-width="90">
      <!--      <FormItem prop="driverName" label="密码">-->
      <!--        <Button type="primary" @click="possworsOne" style="margin-right: 5px;">密码1</Button>-->
      <!--        <Button type="primary" @click="posswordTwo">密码2</Button>-->
      <!--        <Input v-model="setDriverCardParams.possword" type="password" password placeholder="请输入密码">-->
      <!--        </Input>-->
      <!--      </FormItem>-->
      <FormItem prop="driverName" label="驾驶员名">
        <Input v-model="setDriverCardParams.driverName" placeholder="请输入驾驶员名">
        </Input>
      </FormItem>
      <FormItem prop="idCardNum" label="驾驶员身份证">
        <Input v-model="setDriverCardParams.idCardNum" placeholder="请输入驾驶员身份证">
        </Input>
      </FormItem>
      <!--      <FormItem prop="driverLicenseNum" label="从业资格证号">-->
      <!--      <FormItem prop="driverLicenseNum" label="司机卡号">-->
      <!--        <Input v-model="setDriverCardParams.qualificationCode" placeholder="请输入司机卡号">-->
      <!--        </Input>-->
      <!--      </FormItem>-->
      <FormItem prop="organizationNames" label="发证机构名称">
        <Input v-model="setDriverCardParams.organizationNames" placeholder="请输入发证机构名称">
        </Input>
      </FormItem>
      <FormItem prop="date" label="证件有效期">
        <DatePicker style="display: inline-block; width: 200px;" type="date" v-model="setDriverCardParams.date"
                    placeholder="选择日期"></DatePicker>
      </FormItem>
      <Button type="primary" @click="onCleanDriverCardParams" style="margin-right: 5px;">清空</Button>
      <Button type="primary" @click="onSendDriverCardParams">发送</Button>
    </Form>
  </Modal>
</template>

<script>

import Vue from 'vue'
import { mapActions } from 'vuex'
import store from '@/store'
import { genQueryParam, genSortParam } from '@/libs/queryparamhelper'

import MaintainOrderAddMaintainDeviceRecordModal
  from '@/view/om/components/maintain-order-add-maintain-device-record-modal'

export default {
  name: 'rmsetdrivercardmodal',
  components: {},
  props: {
    initValue: null,
    terminalNumValue: null,
    value: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      setDriverCardParams: {
        id: null,
        possword: 'admin',
        driverName: null,
        idCardNum: null,
        qualificationCode: null,
        organizationNames: null,
        indate: null,
        date: null
      }

    }
  },
  methods: {
    ...mapActions([
      'VehicleInfoServ_SearchByName'
    ]),
    visibleChange (val) {
      if (val) {
        this.setDriverCardParams.id = this._initValue
        this.setDriverCardParams.driverName = null
        this.setDriverCardParams.idCardNum = null
        this.setDriverCardParams.qualificationCode = null
        this.setDriverCardParams.organizationNames = null
        this.setDriverCardParams.indate = null
        this.setDriverCardParams.date = null
        this.possworsOne()
      }
    },
    onCleanDriverCardParams () {
      this.setDriverCardParams.possword = 'admin'
      this.setDriverCardParams.driverName = null
      this.setDriverCardParams.idCardNum = null
      this.setDriverCardParams.qualificationCode = null
      this.setDriverCardParams.organizationNames = null
      this.setDriverCardParams.indate = null
      this.setDriverCardParams.date = null
    },
    SendCommand (content) {
      store.dispatch('NetCommandServ_SendCommand', {
        // params: { id: this._initValue, content: '99admin,' + this.setDriverCardParams.possword + ',SICC' + this.setDriverCardParams.driverName + ',' + this.setDriverCardParams.idCardNum + ',' + this.setDriverCardParams.qualificationCode + ',' + this.setDriverCardParams.organizationNames + ',' + this.setDriverCardParams.indate + '!', urgent: false }
        params: { id: this._initValue, content: content, urgent: false }
      }).then(() => {
        this.$Message.success('发送成功')
        let queryParams = []
        queryParams.push(genQueryParam('terminalNum', 'EQ', this._terminalNumValue))
        store.dispatch('DriverCardDataResultServ_GetPage', {
          params: null,
          urlparams: {
            q: queryParams
          }
        }).then(res => {
          // console.log(res)
          if (store.getters.get_DriverCardDataResult_GetPageResult) {
            // console.log(store.getters.get_DriverCardDataResult_GetPageResult)
            let driverCardDataResults = store.getters.get_DriverCardDataResult_GetPageResult.content
            for (let i = 0; i < driverCardDataResults.length; i++) {
              if (driverCardDataResults[i].processState != 3) {
                driverCardDataResults[i].processRemark = '写卡'
                driverCardDataResults[i].processState = 3
                store.dispatch('DriverCardDataResultServ_AddProcessRemark', {
                  params: driverCardDataResults[i]
                }).then(() => {
                  // this.refreshPage(this.pageFilter)
                }).catch(err => {
                  this.$Message.error(err)
                })
              }
            }
          }
        }).catch(err => {
          console.log(err)
        })
      }).catch(err => {
        this.$Message.error(err)
      })
    },
    onSendDriverCardParams () {
      if (this.setDriverCardParams.driverName == null) {
        this.$Message.error('请输入驾驶员名')
        return
      }
      if (this.setDriverCardParams.idCardNum == null) {
        this.$Message.error('请输入驾驶证号')
        return
      }
      if (this.setDriverCardParams.idCardNum != null) {
        this.setDriverCardParams.qualificationCode = this.setDriverCardParams.idCardNum
      }
      if (this.setDriverCardParams.date == null) {
        this.$Message.error('请输入有效期')
        return
      } else {
        this.setDriverCardParams.indate = this.setDriverCardParams.date.Format('yyyyMMdd').substring(2)
      }
      // console.log('99admin,' + this.setDriverCardParams.possword + ',SICC' + this.setDriverCardParams.driverName + ',' + this.setDriverCardParams.idCardNum + ',' + this.setDriverCardParams.qualificationCode + ',' + this.setDriverCardParams.organizationNames + ',' + this.setDriverCardParams.indate + '!')

      this.SendCommand('99admin,admin,SICC' + this.setDriverCardParams.driverName + ',' + this.setDriverCardParams.idCardNum + ',' + this.setDriverCardParams.qualificationCode + ',' + this.setDriverCardParams.organizationNames + ',' + this.setDriverCardParams.indate + '!')

      setTimeout(() => {
        this.SendCommand('99admin,JC336699,SICC' + this.setDriverCardParams.driverName + ',' + this.setDriverCardParams.idCardNum + ',' + this.setDriverCardParams.qualificationCode + ',' + this.setDriverCardParams.organizationNames + ',' + this.setDriverCardParams.indate + '!')
      }
        , 1000)

      setTimeout(() => {
        this.SendCommand('99admin,,SICC' + this.setDriverCardParams.driverName + ',' + this.setDriverCardParams.idCardNum + ',' + this.setDriverCardParams.qualificationCode + ',' + this.setDriverCardParams.organizationNames + ',' + this.setDriverCardParams.indate + '!')
      }
        , 2000)
      setTimeout(() => {
        this.SendCommand('99admin,870315,SICC' + this.setDriverCardParams.driverName + ',' + this.setDriverCardParams.idCardNum + ',' + this.setDriverCardParams.qualificationCode + ',' + this.setDriverCardParams.organizationNames + ',' + this.setDriverCardParams.indate + '!')
      }
        , 3000)

      setTimeout(() => {
        this.SendCommand('99870315,870315,SICC' + this.setDriverCardParams.driverName + ',' + this.setDriverCardParams.idCardNum + ',' + this.setDriverCardParams.qualificationCode + ',' + this.setDriverCardParams.organizationNames + ',' + this.setDriverCardParams.indate + '!')
      }
        , 4000)

      setTimeout(() => {
          this.SendCommand('99admin,JcBOZSJCB0,SICC' + this.setDriverCardParams.driverName + ',' + this.setDriverCardParams.idCardNum + ',' + this.setDriverCardParams.qualificationCode + ',' + this.setDriverCardParams.organizationNames + ',' + this.setDriverCardParams.indate + '!')
        }
        , 5000)

      // store.dispatch('NetCommandServ_SendCommand', {
      //   // params: { id: this._initValue, content: '99admin,' + this.setDriverCardParams.possword + ',SICC' + this.setDriverCardParams.driverName + ',' + this.setDriverCardParams.idCardNum + ',' + this.setDriverCardParams.qualificationCode + ',' + this.setDriverCardParams.organizationNames + ',' + this.setDriverCardParams.indate + '!', urgent: false }
      //   params: { id: this._initValue, content: '99admin,' + this.setDriverCardParams.possword + ',SICC' + this.setDriverCardParams.driverName + ',' + this.setDriverCardParams.idCardNum + ',' + this.setDriverCardParams.qualificationCode + ',公安局,990921!', urgent: false }
      // }).then(() => {
      //   this.$Message.success('发送成功')
      //   let queryParams = []
      //   queryParams.push(genQueryParam('terminalNum', 'EQ', this._terminalNumValue))
      //   store.dispatch('DriverCardDataResultServ_GetPage', {
      //     params: null,
      //     urlparams: {
      //       q: queryParams
      //     }
      //   }).then(res => {
      //     // console.log(res)
      //     if (store.getters.get_DriverCardDataResult_GetPageResult) {
      //       // console.log(store.getters.get_DriverCardDataResult_GetPageResult)
      //       let driverCardDataResults = store.getters.get_DriverCardDataResult_GetPageResult.content
      //       for (let i = 0; i < driverCardDataResults.length; i++) {
      //         if (driverCardDataResults[i].processState != 3) {
      //           driverCardDataResults[i].processRemark = '写卡'
      //           driverCardDataResults[i].processState = 3
      //           store.dispatch('DriverCardDataResultServ_AddProcessRemark', {
      //             params: driverCardDataResults[i]
      //           }).then(() => {
      //             // this.refreshPage(this.pageFilter)
      //           }).catch(err => {
      //             this.$Message.error(err)
      //           })
      //         }
      //       }
      //     }
      //   }).catch(err => {
      //     console.log(err)
      //   })
      // }).catch(err => {
      //   this.$Message.error(err)
      // })
    },
    possworsOne () {
      this.setDriverCardParams.possword = 'admin'
    },
    posswordTwo () {
      this.setDriverCardParams.possword = 'JC336699'
    }
  },
  computed: {
    _value: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
        this.$emit('change', val)
      }
    },
    _initValue: {
      get () {
        return this.initValue
      },
      set (val) {
        // this.$emit('input', val);
        // this.$emit('change', val);
      }
    },
    _terminalNumValue: {
      get () {
        return this.terminalNumValue
      },
      set (val) {
        // this.$emit('input', val);
        // this.$emit('change', val);
      }
    }
  },
  mounted () {
    this.$nextTick(() => {

    })
  }
}
</script>
